
export default {
    props: {
        isOpen: {
            type: Boolean,
        },
        isClose: {
            type: Function,
        },
        isOk: {
            type: Function,
        },
    },
    data() {
        return {
            datepicker: false,
            dates: [],
            dateParams: [],
            menu: false
        }
    },
    watch: {
        dateParams(val) {
            this.$emit("sendStartTime", val);
        },
    },
    methods: {
        async initialize() {
            var today = new Date();
            var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
            var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0)
            var strlastDayOfMonth = (lastDayOfMonth.getFullYear())
                + "-" + ("00" + (lastDayOfMonth.getMonth() + 1)).slice(-2)
                + "-" + ("00" + lastDayOfMonth.getDate()).slice(-2)
            var strstrlastDayOfMonth = (firstDayOfMonth.getFullYear())
                + "-" + ("00" + (firstDayOfMonth.getMonth() + 1)).slice(-2)
                + "-" + ("00" + firstDayOfMonth.getDate()).slice(-2)
            this.dates = [strstrlastDayOfMonth, strlastDayOfMonth]
        },
        async isCloseDatepicker() {
            this.menu = false
        },
    },
    mounted() {
        this.initialize()
    },
    computed: {
        dateRangeText() {


            let startTime = this.dates[0] > this.dates[1] ? this.dates[1] : this.dates[0]
            let endTime = this.dates[0] > this.dates[1] ? this.dates[0] : this.dates[1]

            this.dateParams = {
                starttime: new Date(startTime).getTime(),
                endtime: new Date(endTime).getTime(),
            }

            return this.dates.join(' ~ ')
        },
    },
}